module.exports = __webpack_public_path__ + "static/img/map7_relation.6d55f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map7_relation.jpg
// module id = zN5b
// module chunks = 1